import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import AdminProductListAdFragment from '../fragments/AdminProductListAdFragment';

export default gql`
query adminProductListAdsQuery($filters: AdminProductListAdFilter, $sortBy: AdminProductListAdOrder, $count: Int!, $page: Int) {
    adminProductListAds(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...AdminProductListAdFragment
        }
    }
}
${PaginatorInfoFragment}
${AdminProductListAdFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminProductListAdsQuery.ts